import gql from 'graphql-tag';

export const CONTACT_CONTENT_QUERY = gql`
  query getSuperContentByUrl($url: String!) {
    SuperContent(Url: $url) {
      Id
      Url
      IxName
      Title
      Text
    }
  }
`;

export const CONTACT_CONTENT_VARIABLES = {
  url: '/radyod-iletisim-aydinlatma-metni',
};
